<div class="containerWrapper">
  <!-- <mat-progress-bar mode="indeterminate" *ngIf="showTemplatesProgress"></mat-progress-bar> -->
  <div class="titleContainer" >
    <h1>{{ 'All Projects' | translate }}</h1>
    <mat-slide-toggle [(ngModel)]="showAllProjects" color="primary" (ngModelChange)="showAllProjectsFn($event)"
      class="projectsStatus extrudedItem"> {{ 'Show All Projects' | translate }} </mat-slide-toggle>
    <mat-slide-toggle [(ngModel)]="checked" color="primary" class="projectsStatus extrudedItem" *ngIf="showAllProjects">
      {{ 'Hide Inactive Projects' | translate }} </mat-slide-toggle>
    <mat-form-field appearance="outline" id="searchProjectNumber" *ngIf="!showAllProjects"
      (keyup)="applyFilter($event)">
      <mat-label>{{ 'Search Project Number' | translate }}</mat-label>
      <input matInput placeholder="1111" />
    </mat-form-field>
    <div id="projectsLimit" class="extrudedItem">
      <div class="top-row">
        <div class="left-column">
          <div class="title">
            <mat-icon class="boltIcon">bolt</mat-icon>
            <p>{{ 'Plan Usage' | translate }}</p>
          </div>
          <div class="subtitle">
            {{ 'Manage all your apps, websites, POS, and QR menus in one place.' | translate }}
          </div>
        </div>
        <div class="right-column">
          <div class="limits">
            <span class="total-projects">{{ 'Total Projects' | translate }} <span class="count">{{ builderService.projectsPremiumCount }} / {{ builderService.projectsLimit }} Created</span></span>
          </div>
        </div>
      </div>
      <div class="bottom-row">
        <div class="progress-wrapper">
          <div class="progressContainer">
            <mat-icon class="icon" *ngIf="builderService.projectsPremiumCount >= builderService.projectsLimit">error_outline</mat-icon>
            <div class="progress-bar">
              <div class="progress"
                  [style.width.%]="projectPercentage"
                  [style.background-color]="getProgressColor(projectPercentage)">
              </div>
            </div>
          </div>
          <div class="message" *ngIf="builderService.projectsPremiumCount >= builderService.projectsLimit">
            <p>{{ 'Total projects creation limit reached' | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="titleContainer" *ngIf="loginService.getCurrentUser().admin">
    <mat-slide-toggle [(ngModel)]="showActiveSubscriptions" color="primary"
      (ngModelChange)="showActiveSubscriptionsFn()" class="projectsStatus extrudedItem"> {{ 'Show Active Subscriptions' | translate }}
    </mat-slide-toggle>
  </div>
  <div class="grid">
    <!-- Add Project -->
    <div class="item addProject">
      <div class="content" (click)="createProject()">
        <mat-icon id="addProject">add</mat-icon>
      </div>
      <div class="footer">
        <p>{{ 'Add New Project' | translate }}</p>
      </div>
    </div>
    <!-- Search Result (MOVED TO TOP - appears first when searching, forces new line for vendors) -->
    <div class="item {{ projectResult.type }} {{ projectResult.status }} search-result"
      [ngClass]="this.checked ? 'hideItem' : 'showItem'" *ngIf="showSearchResults">
      <div class="content" (click)="projectResult.status == 'active' ? getProject(projectResult.id, 'clicked') : ''">
        <ul>
          <!-- <li><p class="itemTitle">{{ 'Project Name:' | translate }}</p><p class="itemContent">{{projectResult.id}}</p></li> -->
          <li *ngIf="projectResult.premium_status == 'active'">
            <p class="itemTitle">{{ 'Project Type:' | translate }}</p>
            <p class="itemContent itemType premium">{{ 'Active Subscription' | translate }}</p>
          </li>
          <li>
            <p class="itemTitle">{{ 'Project Status:' | translate }}</p>
            <p class="itemContent">{{ projectResult.status }}</p>
          </li>
          <li>
            <p class="itemTitle">{{ 'Project ID:' | translate }}</p>
            <p class="itemContent">{{ projectResult.id }}</p>
          </li>
          <li>
            <p class="itemTitle">{{ 'URL:' | translate }}</p>
            <p class="itemContent">
              <a href="{{ projectResult.domain }}" target="_blank">{{ projectResult.domain }}</a>
            </p>
          </li>
          <li>
            <p class="itemTitle">{{ 'Email:' | translate }}</p>
            <p class="itemContent">{{ projectResult.email }}</p>
          </li>
        </ul>
      </div>
      <div class="footer">
        <p>{{ projectResult.id }}</p>
        <div class="actions">
          <button class="material-icons" *ngIf="projectResult.status == 'active'"
            (click)="projectResult.status == 'active' ? deleteProject(projectResult.id) : ''">power_settings_new</button>
          <button
            *ngIf="projectResult.status !== 'active' && builderService.projectsPremiumCount < builderService.projectsLimit && projectResult.type !== 'trial'"
            class="material-icons-outlined"
            (click)="projectResult.status !== 'active' ? activateProject(projectResult.id) : ''">power_settings_new</button>
          <!-- <button class="material-icons-outlined">
                        edit
                    </button> -->
        </div>
      </div>
    </div>

    <!-- Force line break after search result -->
    <div class="line-break" *ngIf="showSearchResults"></div>

    <!-- Core Projects -->
    <div class="item {{ $any(project).type }} {{ $any(project).status }}"
      [ngClass]="this.checked ? 'hideItem' : 'showItem'"
      *ngFor="let project of builderService.projects | slice: 0 : renderProjectsLimit">
      <div class="content" (click)="$any(project).status == 'active' ? getProject($any(project).id, 'clicked') : ''">
        <ul>
          <li *ngIf="$any(project).premium_status == 'active'">
            <p class="itemTitle">{{ 'Project Type:' | translate }}</p>
            <p class="itemContent itemType premium">{{ 'Active Subscription' | translate }}</p>
          </li>
          <li>
            <p class="itemTitle">{{ 'Project Status:' | translate }}</p>
            <p class="itemContent">{{ $any(project).status }}</p>
          </li>
          <li>
            <p class="itemTitle">{{ 'Project ID:' | translate }}</p>
            <p class="itemContent">{{ $any(project).id }}</p>
          </li>
          <li>
            <p class="itemTitle">{{ 'URL:' | translate }}</p>
            <p class="itemContent">
              <a href="{{ $any(project).domain }}" target="_blank">{{ $any(project).domain }}</a>
            </p>
          </li>
          <li>
            <p class="itemTitle">{{ 'Email:' | translate }}</p>
            <p class="itemContent">{{ $any(project).email || user_email }}</p>
          </li>
        </ul>
      </div>
      <div class="footer">
        <p>{{ $any(project).id }}</p>
        <div class="actions">
          <button class="material-icons" *ngIf="$any(project).status == 'active'"
            (click)="$any(project).status == 'active' ? deleteProject($any(project).id) : ''">power_settings_new</button>
          <button
            *ngIf="$any(project).status !== 'active' && builderService.projectsPremiumCount < builderService.projectsLimit && $any(project).type !== 'trial'"
            class="material-icons-outlined"
            (click)="$any(project).status !== 'active' ? activateProject($any(project).id) : ''">power_settings_new</button>
          <!-- <button class="material-icons-outlined">
                        edit
                    </button> -->
        </div>
      </div>
    </div>

    <!-- Vendors Projects Title -->
    <div class="vendors-title" *ngIf="this.vendor.vendorsList && this.vendor.vendorsList.length > 0">
      <h2>{{ 'Vendors Projects' | translate }}</h2>
    </div>
    
    <!-- Vendor Projects (now appears after search results) -->
    <ng-container *ngIf="this.vendor.vendorsList.length || this.vendor.superVendorId">
      <button class="stacksBtn green" *ngIf="this.vendor.superVendorId && this.vendor.superVendorId !== this.builderService.selectedProject" (click)="getProject(vendor.superVendorId, 'clicked')">{{ 'Go to Super Vendor' | translate }}</button>
      <div class="item" (click)="vendorProject.activation == true ? getProject(vendorProject.id, 'clicked') : ''"
        *ngFor="let vendorProject of this.vendor.vendorsList">
        <div class="content">
          <ul>
            <!-- <li><p class="itemTitle">{{ 'Project Name:' | translate }}</p><p class="itemContent">{{projectResult.id}}</p></li> -->
            <li *ngIf="vendorProject.activation == true">
              <p class="itemTitle">{{ 'Project Type:' | translate }}</p>
              <p class="itemContent itemType premium">{{ 'Active Subscription' | translate }}</p>
            </li>
            <li>
              <p class="itemTitle">{{ 'Project ID:' | translate }}</p>
              <p class="itemContent">{{ vendorProject.id }}</p>
            </li>
            <li>
              <p class="itemTitle">{{ 'Email:' | translate }}</p>
              <p class="itemContent">{{ vendorProject.email }}</p>
            </li>
          </ul>
      </div>
    </div>
  </ng-container>
  </div>
</div>